document.addEventListener('turbolinks:load', function() {
  var sendBtn = document.getElementById('magic-link-send-btn');
  var emailInput = document.getElementById('magic_link_email');
  var formDiv = document.getElementById('magic-link-form');
  var sentDiv = document.getElementById('magic-link-sent');

  if (!sendBtn || !formDiv) return;

  var messages = formDiv.dataset;

  sendBtn.addEventListener('click', function() {
    var email = emailInput.value.trim();
    if (!email) {
      alert(messages.errorRequired);
      return;
    }

    sendBtn.disabled = true;
    sendBtn.textContent = '...';

    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    var token = csrfToken ? csrfToken.getAttribute('content') : '';

    fetch(formDiv.dataset.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify({ email: email })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw new Error(data.error || messages.errorFailed);
        });
      }
      return response.json();
    })
    .then(function(data) {
      if (data.success) {
        formDiv.style.display = 'none';
        sentDiv.style.display = 'block';
      } else {
        alert(data.error || messages.errorFailed);
        sendBtn.disabled = false;
        sendBtn.textContent = messages.btnLabel;
      }
    })
    .catch(function(err) {
      alert(err.message || messages.errorFailed);
      sendBtn.disabled = false;
      sendBtn.textContent = messages.btnLabel;
    });
  });
});
